export class Site {
    constructor() {
    }
    bind() {
    }
}
